import * as yup from "yup";

export const personalInfoSchema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: yup.string().required("Phone number is required"),
  city: yup.string().required("City is required"),
  personalPositionCompany: yup.string().required("Job title is required"),
  businessName: yup.string().required("Company name is required"),
  // isEmailUpdates: yup.number().required("Email updates consent is required").oneOf([1], "Email updates consent is required"),
  // isGDPRConsent: yup.number().required("GDPR consent is required").oneOf([1], "GDPR consent is required"),
});

export const membershipSchema = yup.object().shape({
  membershipName: yup.string().required("Please select a membership"),
  isAnnualMembership: yup.number().oneOf([0, 1]).required(),
});

export const termsSchema = yup.object().shape({
  isTermConditions: yup
    .number()
    .required("You must agree to the Terms and Conditions")
    .oneOf([1], "You must agree to the Terms and Conditions"),
  isDirectory: yup
    .number()
    .required("You must agree to be added to SMBF's Directory")
    .oneOf([1], "You must agree to be added to SMBF's Directory"),
});

export const checkoutSchema = yup.object().shape({
  cardNumber: yup.string().required("Card number is required"),
  expiryMonth: yup.string().required("Expiry month is required"),
  expiryYear: yup.string().required("Expiry year is required"),
  cvc: yup.string().required("CVC is required"),
  billingAddress: yup.string().required("Billing address is required"),
});
